import { Injectable } from '@angular/core';
import {
  IRegisterUserTrailCommandRequest,
  RegisterUserTrailCommand
} from './command/registerUserTrail.command';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConnectionServices } from '../authentication/connection/connection.service';

@Injectable({ providedIn: 'root' })
export class UserTrailService {
  constructor(private _connectionService: ConnectionServices) {}

  public register(request: IRegisterUserTrailCommandRequest): Observable<boolean> {
    const cmd = new RegisterUserTrailCommand();
    cmd.setParameters(request);

    return this._connectionService.Request(cmd).pipe(
      // si no te interesa la respuesta, devolvemos true cuando complete OK
      map(() => true),
      catchError((error) => throwError(() => error))
    );
  }
}
